import { useState, useEffect } from "react";

import api from '../api/axios';

import CurrencyDisplay from "./dash_component/CurrencyDisplay";
import getDate from "./dash_component/getDate";

import { RiFileList3Line } from "react-icons/ri";
import { CiSquareAlert } from "react-icons/ci";

import styles from "./dash_styles/dashboard.module.css"

const Dashboard = ({ profile }) => {
    const [orders, setOrders] = useState([]);
    const [lowStockProducts, setLowStockProducts] = useState([]);
    const [users, setUsers] = useState([]);
    const [feedback, setFeedback] = useState([]);

    const fetchOrders = async () => {
        try {
            const res = await api.get('/order');
            const fetchedOrders = res.data.orders || [];
            setOrders(fetchedOrders);

        } catch (error) {
            console.error('Error fetching orders', error);
        }
    };

    const fetchProducts = async () => {
        try {
            const res = await api.get('/products');
            const products = res.data || [];
            const lowStock = products.filter(p => p.quantity <= 5);
            setLowStockProducts(lowStock);
        } catch (error) {
            console.error('Error fetching products', error);
        }
    };

    const fetchUsers = async () => {
        try {
            const res = await api.get('/user');
            setUsers(res.data.users);
        } catch (error) {
            console.error('Error fetching users', error);
        }
    };

    const fetchFeedbackData = async () => {
        try {
            const res = await api.get('/feedback');
            setFeedback(res.data);
        } catch (error) {
            console.error('Error fetching feedback', error);
        }
    };

    useEffect(() => {
        fetchOrders();
        fetchProducts();
        fetchUsers();
        fetchFeedbackData();
    }, []);

    const userNotAdmin = users.filter(user => user.role === 'user');
    const completedOrders = orders.filter(order => order.status.toLowerCase() === 'completed');
    const canceledOrders = orders.filter(order => order.status.toLowerCase() === 'canceled');
    const pendingOrders = orders.filter(order => order.status.toLowerCase() === 'pending');
    const processingOrders = orders.filter(order => order.status.toLowerCase() === 'processing');

    return (
        <div className={styles.dashmain}>
            
            <div className={styles.welcome}>
                <p>Welcome back, <span>{profile?.first_name}</span> glad to see you again!</p>
            </div>

            <div className={styles.middle}>
                <div className={styles.statsContainer}>
                    <div className={styles.statCard}>
                        <div className={styles.stat}>
                            <p>{orders.length}</p>
                        </div>
                        <div className={styles.statInfo}>
                            <p className={styles.topText}>Total Orders</p>
                        </div>
                    </div>
                    <div className={styles.statCard}>
                        <div className={styles.stat} style={{ backgroundColor: 'rgba(176, 89, 219, 0.54)'}}>
                            <p>{orders.length}</p>
                        </div>
                        <div className={styles.statInfo}>
                            <p className={styles.topText}>Total</p>
                            <p style={{ color: 'grey'}}>Pending orders</p>
                        </div>
                    </div>
                    <div className={styles.statCard}>
                        <div className={styles.stat}>
                            <p>{userNotAdmin.length}</p>
                        </div>
                        <div className={styles.statInfo}>
                            <p className={styles.topText}>Total</p>
                            <p style={{ color: 'grey'}}>Current users</p>
                        </div>
                    </div>
                    <div className={styles.statCard}>
                        <div className={styles.stat} style={{ backgroundColor: 'rgba(234, 181, 83, 0.54)'}}>
                            <p>{feedback.length}</p>
                        </div>
                        <div className={styles.statInfo}>
                            <p className={styles.topText}>Total</p>
                            <p style={{ color: 'grey'}}>Feedback</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.bottom}>
                <div className={styles.order}>
                    <div className={styles.topContainer}>
                        <div className={styles.labelContainer}>
                            <div className={styles.label}>
                                <p>Order managment</p>
                            </div>
                            <div className={styles.filterOrder}>
                                <div className={styles.filterSelection}>
                                    <p>New orders</p>
                                    <div className={styles.count}><p>2</p></div>
                                </div>
                                <div className={styles.filterSelection}>
                                    <p>Oldest orders</p>
                                    <div className={styles.count}><p>7</p></div>
                                </div>
                            </div>
                        </div>
                        
                        <div className={styles.statusContainer}>
                            <div className={styles.statusBox}>
                                <p>Pending</p>
                                <div className={styles.count}><p>{pendingOrders.length}</p></div>
                            </div>
                            <div className={styles.statusBox}>
                                <p>Processing</p>
                                <div className={styles.count}><p>{processingOrders.length}</p></div>
                            </div>
                            <div className={styles.statusBox}>
                                <p>Completed</p>
                                <div className={styles.count}><p>{completedOrders.length}</p></div>
                            </div>
                            <div className={styles.statusBox}>
                                <p>Canceled</p>
                                <div className={styles.count}><p>{canceledOrders.length}</p></div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.mainOrderList}>
                        <div className={styles.topOrderList}>
                            <p>ORDERS</p>
                        </div>
                        <div className={styles.listWrapper}>
                            <div className={styles.innerWrapper}>
                                <div className={styles.orderWindow}>
                                    {orders.length === 0 ? (
                                        <p>No orders yet</p>
                                    ) : (
                                        <div className={styles.mainTableContainer}>
                                            <div className={styles.outerTable}>
                                                <form >
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th className={styles.col1}>po#</th>
                                                                <th className={styles.col2}>status</th>
                                                                <th className={styles.col3}>item amount</th>
                                                                <th className={styles.col4}>total</th>
                                                                <th className={styles.col5}>date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Array.isArray(orders) && orders.map(o => (
                                                                <tr key={o.id} >
                                                                    <td><p>FED-02340{o.id}</p></td>
                                                                    <td><p>{o.status}</p></td>
                                                                    <td><p>{o.items.length}</p></td>
                                                                    <td><CurrencyDisplay amount={o.total} currency='CAD'/></td>
                                                                    <td>{getDate(o.created_at)}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </form>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className={styles.stocks}>
                    <div className={styles.labelContainers}>
                        <div className={styles.label}>
                            <p>Stocks alerts</p>
                        </div>
                    </div>
                    <div className={styles.stockContainer}>
                        <div className={styles.innerContainer}>
                            {lowStockProducts.length === 0 ? (
                                <p>No low stock alerts</p>
                            ) : (
                                <div className={styles.stockList}>
                                    {lowStockProducts.map(p => (
                                        <div className={styles.stockListContainer}>
                                            <div className={styles.topStock}>
                                                <div className={styles.iconStock}>
                                                    <RiFileList3Line/>
                                                </div>
                                                <div>
                                                    <p>{p.title} - {p.type}</p>
                                                </div>
                                            </div>
                                            <div className={styles.idTag}><p>HKSI-00{p.id}</p></div>
                                            <div className={styles.stockBottom}>
                                                <div className={styles.alerts}>
                                                    <div className={styles.alertBox}>
                                                        <p>LOW</p>
                                                    </div>
                                                    <div className={styles.alertBox2}>
                                                        <p>REPLENISH</p>
                                                    </div>
                                                </div>
                                                <div className={styles.stockBox}>
                                                    <div className={styles.alertIcon}><CiSquareAlert/></div>
                                                    <div><p>QUANTITY: {p.quantity}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        
                    </div>
                        
                </div>
            </div>
        </div>
    );
};

export default Dashboard